module.exports = __webpack_public_path__ + "img/esfp.e2554261.png";